module.exports = __webpack_public_path__ + "1791188489487/fonts/WorkSans-Light.af064db.woff2";